import React from "react";
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


const FindResources = () =>{
  
  return (
    <div className="ResearchToolCollections">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/findresource.jpg" alt=""/>
      </section>
     
      <section  className="research-box-area">
           <Container>
              <div className='information-content'>
                <h2>Find Resources</h2>
                <p>Our library houses a unique and diverse collection of 24000 print books, 100,000 e-books and 9000+ Journals</p>
              </div>
              <Row className="ParentBorderBox">
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <img src="./assets/img/researchtool/e-resource-icon.svg" alt=""/>
                      <h5>E-Resources/Databases</h5>
                      <p>We have subscribed to a variety of online resources to meet the academic needs of our departments. Click on the link(s) below to explore these resources.</p>
                      <div className="blockLinks">
                      <Link as={Link} to="/DSSE" className='link-btn'>
                        <img src="./assets/img/link-icon.svg" alt="" />DSSE
                      </Link>
                      <Link as={Link} to="/AHSS" className='link-btn'>
                        <img src="./assets/img/link-icon.svg" alt="" />AHSS
                      </Link>
                        </div>
                      {/* <Link as={Link} to="" className='btn-dfault'>
                        See Details
                      </Link> */}
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <img src="./assets/img/researchtool/newspaper-icon.svg" alt=""/>
                      <h5>Newspaper & Magazine</h5>
                      <p>The HU library provides access to six newspapers, including the world-renowned Chronicle of Higher Education. These newspapers are available in English, Urdu, and Sindhi. We also subscribe to Harvard Business Review, Scientific American, and Readers Digest.</p>
                      <Link as={Link} to="/NewspaperMagazine" className='btn-dfault'>
                        See Details
                      </Link>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <img src="./assets/img/researchtool/free-open-access-icon.svg" alt=""/>
                      <h5>Free/Open Access Resources</h5>
                      <p>Our library staff has curated a list of online, free, and open-access resources to enhance the diversity of available materials.</p>
                      <Link as={Link} to="/FreeOpenAccessResources" className='btn-dfault'>
                        See Details
                      </Link>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <img src="./assets/img/researchtool/self-learning-icon.svg" alt=""/>
                      <h5>Search for a Book</h5>
                      <p>Dive deep into exploring the print collection available at the library.</p>
                      <a href="https://catalog.habib.edu.pk/" className='btn-dfault' target="_blank">
                        See Details
                      </a>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <img src="./assets/img/researchtool/HIRA-icon.svg" alt=""/>
                      <h5>HIRA (Habib Institutional Repositories and Archive)</h5>
                      <p>Interested in exploring the final year thesis and projects of all graduating classes? HIRA institutional repository houses almost all of them.</p>
                      <a href="https://hira.habib.edu.pk/jspui/" className='btn-dfault' target="_blank">
                        See Details
                      </a>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <img src="./assets/img/researchtool/app-1.svg" alt=""/>
                      <h5>Libby App</h5>
                      <p>We have curated a number of self-help books and novels in Audio format. Download the app on your smartphone and listen to audio books on the go.</p>
                      <a href="https://libbyapp.com/library/habibuni" className='btn-dfault' target="_blank">
                        See Details
                      </a>
                    </div>
                  </Col>
              </Row>
           </Container>
      </section>
     
    </div>
  );
}
export default FindResources;